
import Vue from "vue";

export default Vue.extend({
  name: "ScoreRulesBuilder",
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      operators: [
        "<=",
        "<",
        "==",
        ">=",
        ">"
      ],
      items: this.value ?? []
    }
  },
  created() {
    // if (this.items.length <= 0) {
    //   this.addRule()
    // }
  },
  methods: {
    addRule() {
      this.items.push(
          {
            value: 0,
            operator: "<=",
            title: "",
            description: "",
          }
      )
    },
    removeRule(index: number) {
      this.items.splice(index, 1);
    },
    getColFlex(): number {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 12;
        case "sm":
          return 6;
        case "md":
          return 6;
        case "lg":
          return 6;
        case "xl":
          return 6;
        default:
          return 12;
      }
    },
  },
  watch: {
    items: function (its) {
      this.items = its;
      this.$emit("input", its);
    },
    value: function (val) {
      this.items = val;
    }
  }
})
